export default class ActualizarCategoria {
  #repository
  constructor(repository) {
    this.#repository = repository
  }
  async execute(idCategoria, payload) {
    try {
      const result = await this.#repository.actualizarCategoria(idCategoria, payload)
      return result
    } catch (error) {
      throw error
    }
  }
}
